<template>
    <pop-form v-if="state" width="450px" class="see-pay-password">
        <template v-slot:title>
            {{title}}
            <i class="el-icon-close close" @click="close()"></i>
        </template>

        <div class="form-box" v-if="!showPayPassword">
            <div class="input-box">
                <el-input v-model="superPassword" type="password" placeholder="请输入授权码后查看" @keypress.native="e => {if(e.charCode === 13) getPayPassword();}"
                    :autofocus="true"
                ></el-input>
            </div>
            <el-collapse-transition>
            <div class="error-box" v-if="errorMessage">
                {{errorMessage}}
            </div>
            </el-collapse-transition>
        </div>

        <div class="show-password-box" v-else>
            <div v-if="payPassword">
                当前会员消费密码为：<span class="font-red">{{payPassword}}</span>
            </div>
            <div v-else>
                当前会员未设置消费密码
            </div>
        </div>

        <template v-slot:foot>
            <div class="tr foot-box" v-if="!showPayPassword">
                <el-button size="medium" type="primary" @click="getPayPassword">&nbsp;&nbsp;确定&nbsp;&nbsp;</el-button>
            </div>
            <div class="tr foot-box" v-else>
                <el-button size="medium" type="primary" @click="close">&nbsp;&nbsp;关闭&nbsp;&nbsp;</el-button>
            </div>
        </template>
    </pop-form>
</template>

<script>
    import obj from "@/js/obj";
    import PopForm from "@/model/PopForm";
    export default {
        name: "SeePayPassword",
        components: {PopForm},
        props: {
            state: {
                type: Boolean,
                default: false
            },
            storeUid: [Number, String]
        },
        model: {
            prop: "state",
            event: "showChange"
        },
        data: () => ({
            title: "查看消费密码",
            showPayPassword: false,
            superPassword: "",  //授权密码
            errorMessage: "",   //错误提示
            payPassword: "",    //支付密码
        }),
        methods: {
            initData: function () {
                this.showPayPassword = false;
                this.errorMessage = "";
                this.superPassword = "";
                this.payPassword = "";
                this.checkAuthorityOption();
            },
            //检查是否设置授权
            checkAuthorityOption: function () {
                obj.postData("store_option/check_authority_option", {}, res => {
                    if(res.errcode !== 0)
                        this.errorMessage = res.errdesc;
                });
            },
            //关闭
            close: function () {
                this.$emit("showChange", false);
            },
            //获取支付密码
            getPayPassword: function () {
                // this.errorMessage = "您还未设置授权码，请到系统设置 - 门店设置 - 授权设置进行";
                if(!this.superPassword || !this.storeUid)
                    return false;

                obj.postData("store_user/get_pay_password", {
                    store_uid: this.storeUid ? this.storeUid : 0,
                    super_password: this.superPassword
                }, res => {
                    if(res.errcode === 0){
                        this.payPassword = res.data;
                        this.errorMessage = "";
                        this.showPayPassword = true;
                    } else {
                        this.errorMessage = res.errdesc;
                    }
                });
            },
        },
        watch: {
            state: function (t) {
                if(t) this.initData();
            }
        }
    }
</script>

<style scoped>
    .close{
        float: right;
    }
    .form-box{
        padding: 0px 10px;
    }
    .show-password-box{
        padding: 0px 10px;
    }
    .error-box{
        padding: 12px 2px 0px;
        color: #f56c6c;
        font-size: 12px;
    }
    .foot-box{
        padding-right: 10px;
    }
    .font-red{
        color: #f56c6c;
    }

</style>
<style>
    .see-pay-password .el-card__header{
        border-bottom: none;
    }
</style>
